import { render, staticRenderFns } from "./linkSetting.vue?vue&type=template&id=5f35cbbe&scoped=true"
import script from "./linkSetting.vue?vue&type=script&lang=js"
export * from "./linkSetting.vue?vue&type=script&lang=js"
import style0 from "./linkSetting.vue?vue&type=style&index=0&id=5f35cbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35cbbe",
  null
  
)

export default component.exports